import { useEffect, useState } from "react";
import { Gift } from "lucide-react";
import { api, imgUrl } from "../lib/api";
import { useSite } from "../context/SiteContext";
import { Seo } from "../components/site/Seo";
import { PageHeader } from "../components/site/PageHeader";
import { SectionTitle } from "../components/site/SectionTitle";
import { DiscountBadge } from "../components/site/ServiceCard";
import { RichText } from "../components/site/RichText";
import { ContactSection } from "../components/site/ContactSection";
import { GiftForm } from "../components/site/GiftForm";

const INTRO = `Sevdiklerinize verebileceğiniz en anlamlı hediyelerden biri, kendilerine ayıracakları huzurlu bir zamandır. Lunessa Spa Masaj hediye çeki ile annenize, eşinize, arkadaşınıza ya da iş arkadaşınıza Sivas Merkez’deki salonumuzda keyifli bir masaj veya spa deneyimi hediye edebilirsiniz.

Hediye çekleri; doğum günleri, yıl dönümleri, Anneler Günü, Sevgililer Günü ya da sadece “iyi ki varsın” demek istediğiniz her an için uygundur. Hazır paketlerimizden birini seçebilir ya da [masaj hizmetlerimiz](/masaj-hizmetleri) arasından tek bir hizmeti hediye edebilirsiniz. Çift masalı odalarımız sayesinde iki kişinin birlikte yaşayacağı bir deneyimi de hediye etmeniz mümkün.

### Hediye Çeki Nasıl Alınır?

Aşağıdaki formda paketi veya hizmeti seçin, alıcının ve kendi adınızı yazın, isterseniz kısa bir not ekleyin. Hediye çekinizin önizlemesi siz yazdıkça hazırlanır. Ardından “WhatsApp ile Hediye Çeki İste” butonuna dokunarak bilgileri bize iletin; ekibimiz en kısa sürede size dönüş yaparak ödeme ve teslim detaylarını paylaşsın.

### Kullanım Bilgisi

Hediye çeki sahibi, randevusunu telefon veya WhatsApp üzerinden kolayca oluşturabilir. Tüm paketlerde geçerli dönemsel kampanyalarımızdan hediye çekleri de yararlanır. Sorularınız için [iletişim](/iletisim) sayfamızdan bize ulaşabilirsiniz.`;

const PackageCard = ({ p, onPick }) => (
  <article className="card-lux group flex flex-col overflow-hidden" data-testid={`gift-package-${p.id}`}>
    <div className="relative aspect-[4/3] overflow-hidden">
      <img src={imgUrl(p.image)} alt={`lunessa-sivas-hediye-ceki-${p.name}`} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
      <DiscountBadge className="absolute left-4 top-4" />
    </div>
    <div className="flex flex-1 flex-col p-6">
      <h3 className="text-lg font-semibold text-emerald-950">{p.name}</h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed text-ink/65">{p.description}</p>
      {p.services && <p className="mt-3 text-xs font-medium text-gold-deep">{p.services}</p>}
      <button type="button" onClick={() => onPick(p.name)} className="btn-emerald mt-5 !py-2.5 text-[13px]" data-testid={`gift-package-pick-${p.id}`}>
        <Gift className="h-4 w-4" /> Bu Paketi Seç
      </button>
    </div>
  </article>
);

export default function GiftPage() {
  const { services } = useSite();
  const [packages, setPackages] = useState([]);
  const [item, setItem] = useState("");
  useEffect(() => {
    api.get("/gift-packages").then((r) => setPackages(r.data));
  }, []);
  const pick = (name) => {
    setItem(name);
    document.getElementById("hediye-formu")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const crumbs = [{ to: "/", label: "Ana Sayfa" }, { to: "/hediye-ceki", label: "Hediye Çeki" }];
  return (
    <>
      <Seo title="Hediye Çeki | Lunessa Spa Masaj Sivas" description="Lunessa Spa Masaj hediye çeki ile sevdiklerinize Sivas’ta masaj ve spa deneyimi hediye edin. Hazır paketler, kişiye özel not ve WhatsApp ile kolay talep." path="/hediye-ceki" breadcrumbs={crumbs} />
      <PageHeader eyebrow="Hediye Çeki" h1="Masaj Hediye Çeki" intro="Sevdiklerinize huzur hediye edin: Sivas’ta masaj ve spa deneyimi için kişiye özel hediye çeki." image="/images/lunessa-sivas-spa-detaylar.webp" imageAlt="lunessa-sivas-masaj-hediye-ceki" crumbs={crumbs} />
      <section className="container-lux max-w-4xl py-16 lg:py-20" data-testid="gift-intro">
        <RichText text={INTRO} />
      </section>
      <section className="bg-cream-grad py-20" data-testid="gift-packages">
        <div className="container-lux">
          <SectionTitle eyebrow="Hazır Paketler" title="Hediye Paketlerimiz" sub="Özel günler için hazırladığımız paketlerden birini seçin." />
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {packages.map((p) => <PackageCard key={p.id} p={p} onPick={pick} />)}
          </div>
        </div>
      </section>
      <section id="hediye-formu" className="container-lux scroll-mt-28 py-20 lg:py-28">
        <SectionTitle eyebrow="Kişiye Özel" title="Hediye Çekinizi Oluşturun" sub="Bilgileri girin, önizlemeyi görün ve WhatsApp ile talebinizi iletin." />
        <GiftForm packages={packages} services={services} item={item} setItem={setItem} />
      </section>
      <ContactSection />
    </>
  );
}
